import React, { Component } from 'react';
import './navbar.css';
class NavBar extends Component {
    render() {
        return (
            <div>

                <header className="header">

                    <a href="/" className="logo">තුරු</a>
                    <input className="menu-btn" type="checkbox" id="menu-btn" />
                    <label className="menu-icon" htmlFor="menu-btn"><span className="navicon" /></label>
                    <ul className="menu">
                        <li><a href="/prod">Our Products</a></li>
                        <li><a href="/#services">Our Services</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="/adminPanel">Admin</a></li>
                    </ul>
                </header>
            </div>
        );
    }
}

export default NavBar;